// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_ExtendInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_ExtendInput — body for POST /subscriptions/extend.
 *
 * Mirrors SubscriptionSweep_StaffExtendInput validation rules.
 */
import { registerContract } from './validate'

export interface Subscriptions_ExtendInput {
days: number
subscription_id?: number
franquia_id?: number
}

registerContract('Subscriptions_ExtendInput', {
  days:            { type: 'number',  required: true },
  subscription_id: { type: 'number',  required: false },
  franquia_id:     { type: 'number',  required: false },
})
